import React, { useMemo } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import FolderOutlinedIcon from "@material-ui/icons/FolderOutlined";
import ViewListOutlinedIcon from "@material-ui/icons/ViewListOutlined";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import AppBarLogo from "./AppBarLogo";
import AppBarNav from "./AppBarNav";
import AppBarUserSlot from "./AppBarUserSlot";
import { AppBarNavChipItem } from "./AppBarNavChip";
import { appBarStyles } from "./appBarTheme";

const styles = (theme: Theme) => createStyles(appBarStyles(theme));

const shouldHideAppBar = (pathname: string, hasUser: boolean) =>
  pathname.search("login") !== -1 ||
  pathname.search("mosaic") !== -1 ||
  (pathname.search("password") !== -1 && !hasUser) ||
  pathname.search("qrcode") !== -1 ||
  pathname.search("verifyCode") !== -1;

const ModernCustomAppBar = (props: any) => {
  const {
    classes,
    user,
    location: { pathname },
    handleLogout,
  } = props;

  const isAdmin =
    user &&
    (user.authorities[0] === "ROLE_ADMIN" ||
      user.authorities[0] === "ROLE_PROJECT_ADMIN");

  const navItems = useMemo(() => {
    const items: AppBarNavChipItem[] = [];
    if (isAdmin) {
      items.push({
        href: "/projects/0?sort=createdDate,desc",
        label: "Projets",
        Icon: FolderOutlinedIcon,
      });
    }
    if (user) {
      items.push({
        href: "/batches/0?sort=createdDate,desc",
        label: "Lots",
        Icon: ViewListOutlinedIcon,
      });
    }
    if (isAdmin) {
      items.push(
        {
          href: "/userlist/0?sort=firstName,asc",
          label: "Utilisateurs",
          Icon: PeopleOutlineIcon,
        },
        {
          href: "/analyse",
          label: "Analyse",
          Icon: AssessmentOutlinedIcon,
        },
      );
    }
    return items;
  }, [isAdmin, user]);

  if (shouldHideAppBar(pathname, !!user)) {
    return null;
  }

  return (
    <AppBar position="fixed" elevation={2} className={classes.appBar}>
      <Toolbar disableGutters className={classes.toolbar}>
        <AppBarLogo />
        <AppBarNav items={navItems} />
        <AppBarUserSlot user={user} onLogout={handleLogout} />
      </Toolbar>
    </AppBar>
  );
};

export default withStyles(styles)(withRouter(ModernCustomAppBar));
